import { render } from "./ParcoursComponent.vue?vue&type=template&id=163aab12"
import script from "./ParcoursComponent.vue?vue&type=script&lang=js"
export * from "./ParcoursComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__